import styled from "styled-components";
import theme from "../styles/theme";
import Button from "./Button";
import FlexBox, { FlexGrow } from "./FlexBox";
import Modal from "./Modal";
import { Icon } from "@mui/material";
import MinimalSelect from "./MinimalSelect";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { components } from "react-select";
import { Icon as MuiIcon, TableBody, TableHead, TableRow } from "@mui/material";
import { PillarType } from "../types/Roadmap";
import { useNavigate } from "react-router-dom";
import { ClickableIcon } from "./Icon";
import { VersionContext } from "../context/VersionContext";

type MoveCompetencyProps = {
  setIsErrorOpen: any;
  setIsSnackbarOpen: any;
  category?: string;
  isOpen?: boolean;
  competencyData: any;
  message?: string;
  setMessage: any;
  setOpen: (x: boolean) => void;
  confirmFunction: () => void;
  discardFunction: () => void;
  title: string;
  cancelFunction?: () => void;
};
const Title = styled.div`
  gap: 10px;
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
`;
type PillarCustomType = {
  label: string;
  value: string;
  selected: boolean;
  index: string;
  graphics: any;
  subdomains: Array<any>;
};
type DomainType = {
  label: string;
  value: string;
  knowledge_areas: Array<any>;
};
type KnowledgeType = {
  label: string;
  value: string;
};
const MoveCompetencyModal = ({
  setIsErrorOpen,
  setIsSnackbarOpen,
  message,
  setMessage,
  competencyData,
  category,
  isOpen,
  setOpen,
  confirmFunction,
  discardFunction,
  title,
}: MoveCompetencyProps): JSX.Element => {
  const [pillars, setPillars] = useState<Array<PillarCustomType>>([]);
  const [domains, setDomains] = useState<Array<DomainType>>([]);
  const [knowledgeAreas, setKnowledgeAreas] = useState<Array<KnowledgeType>>(
    []
  );
  const [selectedPillar, setSelectedPillar] = useState<any>();
  const [selectedDomain, setSelectedDomain] = useState<any>();
  const [selectedKnowledge, setSelectedKnowledge] = useState<any>();
  const [showConfirmAlert, setShowConfirmAlert] = useState(false);

  // const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
  // const [isErrorOpen, setIsErrorOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  const updateCategories = () => {
    const body = {
      new_pillar_id: selectedPillar?.value,
      new_subdomain_id: selectedDomain?.value,
      new_area_id: selectedKnowledge?.value,
      competency_id: competencyData.id,
    };
    axios
      .put("/competency/updatecategories", body)
      .then((res) => {
        setMessage("Moved competency successfully!");
        setIsSnackbarOpen(true);
        if (res.data) {
          // window.location.pathname = `/modify/competency/${res.data.competency.competency_code}`;
          // navigate(`/modify/competency`);
          if (competencyData.pillar_id === selectedPillar.value) {
            setOpen(false);
            confirmFunction();
          }
          else {
            navigate(`/modify/competency/${res.data.competency.competency_code}`);

            setOpen(false);
          }
        }
      })
      .catch((err) => {
        setMessage(err.response.data.error);
        setIsErrorOpen(true);
        discardFunction();
      });
  };
  useEffect(() => {
    const e = competencyData.pillar_id;
    if (category === "pillar") {
      fetchPillars();
    } else if (category === "subdomain") {
      fetchPillars();
      onPillarChange({ value: competencyData.pillar_id });
    } else {
      fetchPillars();
      onDomainChange({
        value: competencyData.subdomain_id,
        label: competencyData.subdomain_title,
        knowledge_areas: [],
      });
      onPillarChange({ value: competencyData.pillar_id });
    }
  }, []);
  useEffect(() => {
    if (selectedDomain) mapKnowledgeAreas(selectedDomain);
  }, [selectedDomain]);
  const fetchPillars = () => {
    axios
      .get("/pillar")
      .then((res) => {
        mapPillars(res.data.pillars);
      })
      .catch(() => { });
  };
  const mapPillars = (data: PillarType) => {
    const custom: Array<{
      label: string;
      value: string;
      selected: boolean;
      index: string;
      graphics: any;
      subdomains: Array<any>;
    }> = [];
    data.forEach((element: any) => {
      custom.push({
        value: element.id,
        label: element.title,
        selected: false,
        index: "",
        graphics: element.graphics,
        subdomains: element.subdomains,
      });
    });
    setPillars(custom);
  };

  const CustomSingleValue = (props: any) => {
    return (
      <SingleValue {...props}>
        <MuiIcon
          sx={{
            mr: 1,
            padding: "4px",
            background: props.data.graphics.iconbg,
            boxShadow: props.data.graphics.iconshadow,
            borderRadius: "100px",
            fontSize: "14px",
            verticalAlign: "sub",
          }}
        >
          {props.data.graphics.icon}
        </MuiIcon>
        <span className="react-select__single-value">
          {props.selectProps.getOptionLabel(props.data)}
        </span>
      </SingleValue>
    );
  };
  const { Option, SingleValue } = components;
  const IconOption = (props: any) => (
    <Option {...props}>
      <MuiIcon
        sx={{
          mr: 1,
          padding: "4px",
          background: props.data.graphics.iconbg,
          boxShadow: props.data.graphics.iconshadow,
          borderRadius: "100px",
          verticalAlign: "bottom",
          fontSize: "14px",
        }}
      >
        {props.data.graphics.icon}
      </MuiIcon>
      {props.data.label}
    </Option>
  );

  const { version } = useContext(VersionContext);
  const onPillarChange = (e: any) => {
    setSelectedPillar(e);
    setSelectedDomain({
      value: competencyData.subdomain_id,
      label: competencyData.subdomain_title,
      knowledge_areas: [],
    });
    setSelectedKnowledge("");
    setKnowledgeAreas([]);
    const custom: Array<{
      label: string;
      value: string;
      knowledge_areas: any;
    }> = [];
    axios
      .get(`/subdomain/summary?pillar_id=${e.value}&curriculum_version=${version?.version_number}`)
      .then((res) => {
        res.data.subdomains.forEach((element: any) => {
          custom.push({
            value: element.id,
            label: element.title,
            knowledge_areas: [],
          });
        });
        setDomains(custom);
      })
      .catch(() => { });
  };
  const onDomainChange = (e: any) => {
    setSelectedDomain(e);
    setSelectedKnowledge("");
    const custom: Array<{
      label: string;
      value: string;
      knowledge_areas: any;
    }> = [];
    axios
      .get(`/knowledgearea?subdomain_id=${e.value}`)
      .then((res) => {
        res.data.knowledgeareas.forEach((element: any) => {
          custom.push({
            value: element.id,
            label: element.title,
            knowledge_areas: [],
          });
        });
        setKnowledgeAreas(custom);
      })
      .catch(() => { });
  };
  const mapKnowledgeAreas = (data: DomainType) => {
    const custom: Array<{
      label: string;
      value: string;
    }> = [];
    data.knowledge_areas?.forEach((element: any) => {
      custom.push({
        value: element.id,
        label: element.title,
      });
    });
    category !== "area" && setKnowledgeAreas(custom);
  };
  if (showConfirmAlert) {
    return (
      <Modal
        isOpen={isOpen || false}
        setOpen={setOpen}
        customStyle={{
          overlay: { zIndex: "999999" },
          content: {
            maxWidth: "500px",
            // minHeight: 600,
            padding: "0 16px 24px 16px",
            position: "relative",
          },
        }}
      >
        <FlexBox
          style={{
            height: "64px",
            borderBottom: "1px solid rgb(219, 219, 219)",
          }}
        >
          <Title
            style={{
              fontWeight: "normal",
              fontSize: 20,
              color: "rgb(71, 85, 105)",
            }}
          >
            <Icon>move_up</Icon>
            {title}
          </Title>
        </FlexBox>
        <div style={{ marginTop: 20 }}>
          {/* <FlexBox style={{ display: "flex", justifyContent: "center" }}>
            <Icon style={{ fontSize: "65px" }} color="warning">
              warning_rounded
            </Icon>
          </FlexBox> */}

          <FlexBox
            style={{
              background: "#fffded",
              border: "1px solid #dd742c1c",
              display: "flex",
              flexDirection: "column",
              padding: "20px 10px",
              borderRadius: "5px",
            }}
          >
            <Icon
              style={{ fontSize: "40px", marginBottom: 10 }}
              color="warning"
            >
              warning_rounded
            </Icon>{" "}
            <span>
              Note: if you change the subdomain or knowledge area for a
              competency, you will need to recreate its skills.
            </span>
          </FlexBox>
          <FlexBox justify="end" style={{ marginTop: 20 }}>
            <FlexGrow style={{ flexGrow: "0" }}>
              <div
                className="reduce_opct_onhover"
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "151px",
                  height: "48px",
                  color: "red",
                  // textShadow: "0 2px 2px #ff000045",
                  cursor: "pointer",
                  // backgroundColor: '#c75151'
                }}
                onClick={() => {
                  discardFunction();
                }}
              >
                Discard Changes
              </div>
            </FlexGrow>
            <FlexGrow style={{ flexGrow: "0" }}>
              <Button
                className="reduce_opct_onhover"
                style={{
                  width: "151px",
                  height: "48px",
                  padding: "13px 12px",
                  color: "white",
                  background: theme.color.blueButton,
                  boxShadow: "0 0 5px gray",
                  border: "none",
                }}
                type="button"
                onClick={() => {
                  updateCategories();
                }}
              >
                Save Changes
              </Button>
            </FlexGrow>
          </FlexBox>
        </div>
      </Modal>
    );
  }
  return (
    <>
      {/* <SnackBar
        isOpen={isSnackbarOpen}
        setOpen={setIsSnackbarOpen}
        message={message || ""}
        type="success"
      />
      <SnackBar
        isOpen={isErrorOpen}
        setOpen={setIsErrorOpen}
        header="Error!"
        message={message || ""}
        type="error"
      /> */}
      <Modal
        isOpen={isOpen || false}
        setOpen={setOpen}
        customStyle={{
          overlay: { zIndex: "999999" },
          content: {
            maxWidth: "500px",
            // minHeight: 600,
            padding: "0 16px 24px 16px",
            position: "relative",
          },
        }}
      >
        <FlexBox
          style={{
            height: "64px",
            borderBottom: "1px solid rgb(219, 219, 219)",
          }}
        >
          <Title
            style={{
              fontWeight: "normal",
              fontSize: 20,
              color: "rgb(71, 85, 105)",
            }}
          >
            <Icon>move_up</Icon>
            {title}
          </Title>
        </FlexBox>
        <div style={{ marginTop: 20 }}>
          <Title style={{ color: "#64748b" }}>1. Pillar</Title>
          <MinimalSelect
            isDisabled={category !== "pillar"}
            // menuPortalTarget={document.body}
            value={
              category === "pillar"
                ? pillars.find((v: any) => v.value === selectedDomain)
                : pillars.find((v: any) => v.value === competencyData.pillar_id)
            }
            placeholder="Choose pillar..."
            onChange={(e: any) => {
              onPillarChange(e);
            }}
            styles={{
              container: (base) => ({
                ...base,
                padding: "10px 0",
                width: "100%",
                maxWidth: "100%",
                marginBottom: 20,
              }),
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
                color: theme.color.lightBlueGray800,
              }),
            }}
            options={pillars}
            components={{
              Option: IconOption,
              // ValueContainer: ValueContainerLabel,
              SingleValue: CustomSingleValue,
            }}
          />
          <Title style={{ color: "#64748b" }}>2. Subdomain</Title>
          <MinimalSelect
            isDisabled={category === "area"}
            // menuPortalTarget={document.body}
            placeholder="Choose subdomain..."
            onChange={(e: any) => {
              onDomainChange(e);
            }}
            value={
              category !== "area"
                ? selectedDomain && selectedDomain !== ""
                  ? domains.find((v) => v.value === selectedDomain)
                  : ""
                : domains.find(
                  (v: any) => v.value === competencyData.subdomain_id
                )
            }
            styles={{
              container: (base) => ({
                ...base,
                padding: "10px 0",
                width: "100%",
                maxWidth: "100%",
                marginBottom: 20,
              }),
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
                color: theme.color.lightBlueGray800,
              }),
            }}
            options={domains}
          />
          <Title style={{ color: "#64748b" }}>3. Knowledge Area</Title>
          <MinimalSelect
            // menuPortalTarget={document.body}
            placeholder="Choose knowledge area..."
            onChange={(e: any) => {
              setSelectedKnowledge(e);
            }}
            value={
              selectedKnowledge && selectedKnowledge !== ""
                ? knowledgeAreas.find((v) => v.value === selectedKnowledge)
                : ""
            }
            styles={{
              container: (base) => ({
                ...base,
                padding: "10px 0",
                width: "100%",
                maxWidth: "100%",
                marginBottom: 20,
              }),
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
                color: theme.color.lightBlueGray800,
              }),
            }}
            options={knowledgeAreas}
          />
        </div>
        <FlexBox justify="end">
          <FlexGrow style={{ flexGrow: "0" }}>
            <Button
              style={{
                width: "151px",
                height: "48px",
                padding: "13px 12px",
                color: "rgb(100, 116, 139)",
                // backgroundColor: "#0061ff",
                // boxShadow: "0 0 5px gray",
                border: "2px solid rgb(100, 116, 139)",
              }}
              type="button"
              onClick={() => {
                discardFunction();
              }}
            >
              Cancel
            </Button>
          </FlexGrow>
          <FlexGrow style={{ flexGrow: "0" }}>
            <Button
              style={{
                width: "151px",
                height: "48px",
                padding: "13px 12px",
                color: "white",
                backgroundColor: "#0061ff",
                boxShadow: "0 0 5px gray",
                border: "none",
              }}
              disabled={
                !(selectedPillar && selectedDomain && selectedKnowledge)
              }
              type="button"
              onClick={() => {
                updateCategories();
                // setShowConfirmAlert(true);
              }}
            >
              Save
            </Button>
          </FlexGrow>
        </FlexBox>
      </Modal>
    </>
  );
};

export default MoveCompetencyModal;
